import React from 'react';
import { Box } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

const HeaderSectionSkeleton = () => (
  <Box display="flex" justifyContent="center" flexDirection="column">
    <Skeleton
      variant="text"
      width="70%"
      height={80}
      style={{ margin: '0 auto' }}
    />
    <Skeleton
      variant="text"
      width="80%"
      height={40}
      style={{ margin: '0 auto' }}
    />
    <Skeleton
      variant="text"
      width="200px"
      height={60}
      style={{ margin: '0 auto' }}
    />
  </Box>
);
export { HeaderSectionSkeleton };
